import { QueryKey, useQuery, useQueryClient } from '@tanstack/react-query';
import jwtAxios from '@crema/services/auth/JWT';
import { getLocalStorage, LOCAL_STORAGE_NAMES } from '@libs/storage/src/lib/local';

const getAuthMenus = async () => {
  const res = await jwtAxios.get(`/api/users/menus`);

  if (res.status < 200 || res.status >= 300) {
    throw new Error('Failed to fetch data');
  }

  return res.data;
};

/**
 * 사용자 메뉴 조회
 * /me api 선행 호출 조건으로 진행
 */
export const useAuthMenusQuery = () => {
  const queryClient = useQueryClient();
  const { data, error } = useQuery<any[]>({
    queryKey: ['menus'],
    queryFn: getAuthMenus,
    enabled: !!getLocalStorage(LOCAL_STORAGE_NAMES.TOKEN) && !!queryClient.getQueryData(['/api/users/me']),
  });
  const refreshData = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['menus'],
    });
  };

  return { data, error, refreshData };
};
